/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input, OnInit } from '@angular/core';
import { SubscriptionTypeVoModel } from '@well/domain';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SubscriptionCardViewComponent } from '../subscription-card-view/subscription-card-view.component';
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Component({
  selector: 'well-subscription-card-view-wrapper',
  templateUrl: './subscription-card-view-wrapper.component.html',
  styleUrls: ['./subscription-card-view-wrapper.component.scss'],
  imports: [CommonModule,
            SubscriptionCardViewComponent,
            TranslateModule
  ],
  standalone: true
})
export class SubscriptionCardViewWrapperComponent implements OnInit{

  @Input() subscription: SubscriptionTypeVoModel | undefined = undefined;

  translation = new Map<string, string>();

  constructor(private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.initTranslations();
  }

  getRibbonColor() {
    if(this.subscription && this.subscription.companyType){
      switch (this.subscription.companyType) {
        case CompanyType.customer:
          return {'background-color': '#2ECC71'}
        case CompanyType.forwarder:
          return {'background-color': '#3498DB'}
        case CompanyType.service_provider:
          return {'background-color': '#9B59B6'}
        case CompanyType.customer_with_fleet:
          return {'background-color': '#ffad00'}
        default:
          return {'background-color': '#7f8c8d'}
      }
    }
    return {'background-color': '#7f8c8d'}
  }

  initTranslations() {
    this.translateService.stream('company.subscription-type.companyTypes.customer').subscribe((translations) => {
      this.translation.set(CompanyType.customer, translations);
    });
    this.translateService.stream('company.subscription-type.companyTypes.forwarder').subscribe((translations) => {
      this.translation.set(CompanyType.forwarder, translations);
    });
    this.translateService.stream('company.subscription-type.companyTypes.service_provider').subscribe((translations) => {
      this.translation.set(CompanyType.service_provider, translations);
    });
    this.translateService.stream('company.subscription-type.companyTypes.customer_with_fleet').subscribe((translations) => {
      this.translation.set(CompanyType.customer_with_fleet, translations);
    });
  }
}
